export const environment = {
	production: false,
	/** O ambiente de desenvolvimento é o `.dev` — produção é sem sufixo. */
	apiUrl: 'https://api.dev.nexpo.soft2code.com',
	/**
	 * Liga os adaptadores em memória para os módulos que a API ainda não tem.
	 * Ver `nexpo-web-library/docs/08-REQUISITOS-BACKEND.md`.
	 *
	 * Enquanto isto for `true`, cada tela que roda sobre memória exibe a tarja
	 * de dados de demonstração — ninguém pode confundir número simulado com o
	 * número real da feira.
	 */
	useMockData: true,
	/** Onde moram o app do visitante e os documentos legais — o domínio definitivo, também em desenvolvimento. */
	publicSiteUrl: 'https://nexpoevents.com',
} as const;
